export default __webpack_public_path__ + "static/media/logout.65365555.svg";